document.addEventListener('DOMContentLoaded', function () {
  const interval = setInterval(() => {
    const input = document.getElementById('layer-375310');
    if (!input) return;

    clearInterval(interval);
    console.log("Champ détecté");

    // Appliquer une limite visuelle personnalisée en ignorant les espaces
    input.addEventListener('beforeinput', (e) => {
      const selectionStart = input.selectionStart || 0;
      const selectionEnd = input.selectionEnd || 0;
      const current = input.value.toUpperCase().replace(/\s+/g, '');
      const selectionLength = selectionEnd - selectionStart;
      const addition = e.data ? e.data.replace(/\s+/g, '') : '';
      const total = current.length - selectionLength + addition.length;
      if (total > 10) {
        e.preventDefault();
      }
    });

    input.addEventListener('input', () => {
      const brut = input.value.toUpperCase().replace(/\s+/g, '');
      const lettres = brut.split('');
      let count = lettres.length;

      // Limite stricte à 10 caractères maximum
      if (count > 10) {
        lettres.splice(10);
        count = 10;
      }

      if (count === 0) return;

      // 🎯 Détermine combien de caractères visuels on veut atteindre
      const cible = 22; // Fixe pour forcer un étirement max visuel quel que soit le nombre de lettres

      const espacesTotal = cible - count;
      const intervalles = count - 1;

      // Utiliser des em-spaces pour espacement large
      const espaceLarge = '\u2003';
      const nbEspaces = intervalles > 0 ? Math.floor(espacesTotal / intervalles) : 0;
      const espaceRépété = espaceLarge.repeat(nbEspaces);

      let texteJustifie = '';
      for (let i = 0; i < lettres.length; i++) {
        texteJustifie += lettres[i];
        if (i < intervalles) {
          texteJustifie += espaceRépété;
        }
      }

      input.value = texteJustifie;

      // Mise à jour du mockup
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));

      console.log("Texte justifié (espaces \u2003) :", texteJustifie);
    });
  }, 300);
});
